// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Button, Dropdown, Menu, Avatar, Image, Badge } from 'antd';
import {
  PoweroffOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  DownOutlined,
  UserOutlined,
  NotificationFilled,
} from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import logoPortales from '../../../assets/img/png/logo-portales.png';
import profileUser from '../../../assets/img/png/logo-c.png';
import useUser from '../../../hooks/useUser';

import './menu-top.scss';
import { useAuth } from '../../../hooks';
import { getFilteredDataFromLocalStorage } from '../../../helpers/saveFilterData';
import { useQuery } from '@tanstack/react-query';
import { Customer, get } from '../../../api';

const MenuTop = (props: { menuCollapsed: any; setMenuCollapsed: any }) => {
  const { menuCollapsed, setMenuCollapsed } = props;
  const { user } = useUser();
  const { logout } = useAuth();
  const navigate = useNavigate();

  const [profilePicture, setProfilePicture] = useState(null);
  const [infoCustomer, setInfoCustomer] = useState(null);
  const [customerSelected, setCustomerSelected] = useState(
    user?.customer_id !== null && user?.customer_id !== 0
      ? user?.customer_id
      : ''
  );

  const filter = user.role === 'Sales' ? `?agentId=${user.username}` : '';
  const { isLoading, data: customers } = useQuery<Customer>(['cliente'], () =>
    get<Customer>('/customers/' + filter).then((e) => e.data)
  );

  const menu = (
    <Menu>
      <Menu.Item key="pictureUser">
        <Image
          src={profilePicture ? profilePicture : profileUser}
          style={{ width: 100 }}
        />
      </Menu.Item>
      <Menu.Item key="/profile">
        <Link to="/profile">
          <UserOutlined />
          <span className="nav-text">Perfil</span>
        </Link>
      </Menu.Item>
      <Menu.Item
        key="nameUser"
        danger
        icon={<PoweroffOutlined />}
        onClick={() => logoutUser()}
      >
        Salir
      </Menu.Item>
    </Menu>
  );
  const logoutUser = () => {
    logout();
    navigate('/login');
    // window.location.reload();
  };

  const obtenerDatos = () => {
    const datosObtenidos = getFilteredDataFromLocalStorage('customer');
    if (datosObtenidos !== null && user?.role !== 'Customer') {
      setCustomerSelected(datosObtenidos);
    }
  };

  useEffect(() => {
    if (customers) {
      if (Array.isArray(customers)) {
        const foundItem = customers.find(
          (item) => parseInt(item.id, 10) === customerSelected
        );
        if (foundItem) {
          setInfoCustomer(foundItem);
        }
      } else {
        setInfoCustomer(customers);
      }
    }
  }, [customerSelected, customers]);

  const menuNotifications = (
    <Menu>
      {infoCustomer && (
        <>
          <Menu.Item>
            <span style={{ fontWeight: 'bold' }}>Cliente: </span>
            {infoCustomer.company_name}
          </Menu.Item>
          <Menu.Item>
            <span style={{ fontWeight: 'bold' }}>ID:</span> {infoCustomer.id}
          </Menu.Item>
          <Menu.Item>
            <span style={{ fontWeight: 'bold' }}>RFC:</span> {infoCustomer.rfc}
          </Menu.Item>
          <Menu.Item>
            <span style={{ fontWeight: 'bold' }}> Teléfono: </span>
            {infoCustomer.phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')}
          </Menu.Item>
          <Menu.Item>
            <span style={{ fontWeight: 'bold' }}>Correo: </span>
            {infoCustomer.email}
          </Menu.Item>
        </>
      )}
      {!infoCustomer && (
        <Menu.Item>
          <span style={{ fontWeight: 'bold' }}>No se encontró cliente </span>
        </Menu.Item>
      )}
    </Menu>
  );
  return (
    <div className="menu-top">
      <div className="menu-top__left">
        <img
          src={logoPortales}
          alt="apLogo"
          style={{ width: 100, marginLeft: 20 }}
        />
        <Button
          style={{ marginTop: 10 }}
          icon={menuCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          type="link"
          size="large"
          onClick={() => setMenuCollapsed(!menuCollapsed)}
        ></Button>
      </div>

      <div className="menu-top__right">
        <Dropdown
          trigger={['click']}
          overlay={menuNotifications}
          onClick={() => obtenerDatos()}
          // style={{ marginRight: 30 }}
        >
          <Badge style={{ marginRight: 20 }}>
            <UserOutlined
              style={{
                fontSize: 20,
                color: 'white',
                marginRight: 30,
              }}
            />
          </Badge>
        </Dropdown>
        <Dropdown overlay={menu}>
          <a href="javascript: void(0)" className="ant-dropdown-link">
            <Avatar
              shape="circle"
              src={profilePicture ? profilePicture : profileUser}
              style={{ marginRight: 5 }}
            />{' '}
            {/* {person?.name} */}
            <DownOutlined />
          </a>
        </Dropdown>
      </div>
    </div>
  );
};

export default MenuTop;
